import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const InputContainerCompiled = styled.div({
	display: 'flex',
	alignItems: 'center',
	padding: `${token('space.100')} 0`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SelectContainerCompiled = styled.div({
	width: 250,
	position: 'relative',
	flex: 1,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ClearButtonCompiled = styled.button({
	cursor: 'pointer',
	background: 'none',
	border: token('space.0'),
	font: token('font.body.small'),
	paddingTop: token('space.075'),
	paddingRight: token('space.150'),
	paddingBottom: token('space.075'),
	paddingLeft: token('space.150'),
	color: token('color.text.subtle'),
	'&:hover': {
		textDecoration: 'underline',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FilterHeaderCompiled = styled.label({
	font: token('font.body'),
	color: token('color.text.subtlest'),
	margin: 0,
	width: 100,
});
